// extracted by mini-css-extract-plugin
export default {"KeyGiverDropsView":"KeyGiverDropsView_KeyGiverDropsView__K7nS0"};